import styled from "styled-components";

export const FolderInformationSlideoutContainer = styled.div`
    padding-top: 24px;
    display: flex;
    flex-direction: column;
    gap: 32px;
`

export const FolderInformationSlideoutHeader= styled.div`
    display: flex;
    flex-direction: column;
    gap:8px;
`

export const FolderInformationSlideoutContent= styled.div`
    display: flex;
    flex-direction: column;
    gap: 32px;
`

export const FolderInformationSlideoutOwnerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export const FolderInformationSlideoutOwnerTitle = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`

export const FolderInformationSlideoutOwnerContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`

export const FolderInformationSlideoutOwnerContentTitle = styled.div`
    display:flex;
    flex-direction: row;
    justify-content: flex-start;
    gap:8px;
    align-items: center;
`
export const FolderInformationSlideoutOwnerContentBody = styled.div`
    display:flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 16px;

    & > div.list:nth-child(1) {
        order: 0;
        flex: 1 1 auto;
        align-self: auto;
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
    }
    
    & > div.all:nth-child(2) {
        order: 1;
        flex: 0 1 auto;
        align-self: flex-start;
    }
`

export const FolderInformationSlideoutOwnerContentList = styled.div`
    display:flex;
    flex-direction: row;
    justify-content: flex-start;
    gap:4px;
    align-items: center;
`

export const FolderInformationSlideoutMetaContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export const FolderInformationSlideoutMeta  = styled.div`
    display:flex;
    flex-direction: column;
    gap: 8px;
`

export const FolderInformationSlideoutActions = styled.div`
    display: flex;
    flex-direction: row;
`